import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';

import { routes } from './app.routes';
import { authInterceptor } from './services/auth-interceptor.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    // `scrollPositionRestoration: 'top'` makes every successful navigation
    // (including footer link clicks like /about-jcc) start at the top of
    // the new page, instead of inheriting the scroll position from
    // wherever the user was on the previous route. `anchorScrolling`
    // keeps in-page #fragment links working as expected.
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      }),
    ),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimationsAsync(),
    // Global Material dialog defaults. Per-call `dialog.open(_, { width })`
    // still overrides these. The wider default is sized for content
    // dialogs (edit forms, detail views, tables of scores) — small
    // confirm prompts in the admin pass an explicit narrower width
    // so they don't feel oversized.
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        width: '720px',
        maxWidth: '92vw',
        maxHeight: '92vh',
        autoFocus: 'first-tabbable',
      },
    },
  ]
};
